// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1-_NW","savePackageButton":"ClientWallet_savePackageButton__M2xSt"};